import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "../lib/api";
import { toast } from "sonner";
import { Lock, ArrowRight } from "lucide-react";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(email, password);
      localStorage.setItem("gr_admin_token", res.token);
      localStorage.setItem("gr_admin_email", res.email);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error("Invalid credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <a href="/" className="flex items-center gap-3 mb-12" data-testid="back-home-link">
          <div className="w-10 h-10 bg-forest flex items-center justify-center">
            <span className="text-cream font-serif text-2xl leading-none">G</span>
          </div>
          <div>
            <div className="font-serif text-xl text-forest">Greenroute</div>
            <div className="uppercase text-[10px] tracking-[0.25em] text-sage">Admin Portal</div>
          </div>
        </a>

        <h1 className="font-serif text-4xl text-forest leading-tight mb-2">
          Welcome back.
        </h1>
        <p className="text-graphite text-sm mb-10">
          Sign in to view inquiries and manage your dashboard.
        </p>

        <form onSubmit={onSubmit} className="bg-white border border-bordersoft p-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="uppercase text-[10px] tracking-[0.25em] text-sage mb-2 block">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-email-input"
              className="w-full bg-cream border border-bordersoft px-4 py-3.5 text-ink focus:outline-none focus:border-forest"
            />
          </div>
          <div>
            <label className="uppercase text-[10px] tracking-[0.25em] text-sage mb-2 block">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-password-input"
              className="w-full bg-cream border border-bordersoft px-4 py-3.5 text-ink focus:outline-none focus:border-forest"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-btn"
            className="w-full inline-flex items-center justify-center gap-3 bg-forest text-cream px-7 py-4 text-sm tracking-wider hover:bg-forest/90 transition-colors duration-300 disabled:opacity-60"
          >
            <Lock size={16} />
            {loading ? "Signing in…" : "Sign In"}
            <ArrowRight size={16} />
          </button>
        </form>
      </div>
    </div>
  );
}
